<script setup lang="ts">
import type { Post } from '~/types'
import { format } from 'date-fns'
import { it } from 'date-fns/locale'

definePageMeta({
  layout: 'default'
})
const route = useRoute()

const { data: post } = await useFetch<Post>(`/api/posts/${route.params.slug}`)
</script>

<template>
  <UContainer class="py-12 max-w-3xl">
    <UButton
      to="/blog"
      variant="ghost"
      icon="i-lucide-arrow-left"
      class="mb-8"
    >
      Torna al blog
    </UButton>

    <article v-if="post">
      <div class="mb-8">
        <img
          v-if="post.image"
          :src="post.image"
          :alt="post.title"
          class="w-full h-64 object-cover rounded-lg shadow-md"
        >
        <div v-else class="w-full h-48 bg-gray-200 dark:bg-gray-800 rounded-lg flex items-center justify-center">
          <UIcon name="i-lucide-image" class="w-12 h-12 text-gray-400" />
        </div>
      </div>

      <div class="mb-8">
        <div class="flex flex-wrap items-center gap-4 mb-4 text-sm text-gray-500 dark:text-gray-400">
          <div v-if="post.sport" class="flex items-center gap-1">
            <UBadge color="primary" variant="subtle" size="sm">
              {{ post.sport.name }}
            </UBadge>
          </div>
          <div class="flex items-center gap-1">
            <UIcon name="i-lucide-calendar" class="w-4 h-4" />
            {{ format(new Date(post.createdAt), 'dd MMMM yyyy', { locale: it }) }}
          </div>
          <div class="flex items-center gap-1">
            <UIcon name="i-lucide-eye" class="w-4 h-4" />
            {{ post.views }} visualizzazioni
          </div>
        </div>

        <h1 class="text-4xl font-extrabold text-gray-900 dark:text-white mb-4">
          {{ post.title }}
        </h1>
        <p class="text-xl text-gray-600 dark:text-gray-300 mb-6">
          {{ post.description }}
        </p>

        <div v-if="post.tags && post.tags.length" class="flex flex-wrap gap-2 mb-8">
          <UKbd v-for="tag in post.tags" :key="tag" size="sm">
            #{{ tag }}
          </UKbd>
        </div>

        <UDivider class="my-8" />
      </div>

      <div class="prose prose-primary dark:prose-invert max-w-none" v-html="post.content" />
    </article>
  </UContainer>
</template>
